import { useState } from 'react';

import { tableList } from './const';
import TableTemplate2 from '@components/tableTemplate2';
import { useStateParahub } from '@pages/Parahub/hooks/state/useStateParahub';
import { useFilters } from '@pages/Parahub/hooks/state/useFilters';
import { EmptyStateImage } from '@assets/images';
import { excludeKeys } from '@helpers/utils';
import { find, reject, reverse, sortBy } from 'lodash';
import { useGetStoreConfigList } from '@pages/Parahub/hooks/query/useGetStoreConfig';

const Table = () => {
    const filters = useFilters();
    const stateParahub = useStateParahub();
    const [sortType, setSortType] = useState({ name: '', type: 'default' });

    const apiParams = excludeKeys(filters, ['set', 'reset']);
    const { data, isLoading, error } = useGetStoreConfigList(apiParams);

    const handlePageClick = ({ selected }) => filters.set({ page: selected + 1 });

    const onCheckAllRow = () => stateParahub.set({ exportListParahub: data?.data?.page_data });
    const onChangeLimit = (e) => filters.set({ page: 1, limit: e.target.value });

    const onChangeBulkCheckbox = (value) => {
        stateParahub.set({
            exportListParahub: value,
        });
    };

    const onClickByRow = ({ values }) => {
        let arr = [...stateParahub.exportListParahub];
        const isExist = find(stateParahub.exportListParahub, { id: values?.id });
        if (isExist) arr = reject(arr, { id: values?.id });
        else arr.push(values);
        stateParahub.set({
            exportListParahub: arr,
        });
    };

    const onSort = (sortName) => {
        let type = !sortType || sortType.name !== sortName ? 'asc' : sortType.type === 'asc' ? 'desc' : null;
        setSortType(type ? { name: sortName, type } : null);
        let sorted = [...data?.data?.page_data];
        if (type) {
            sorted = sortBy(sorted, sortName);
            if (type === 'desc') reverse(sorted);
        }
        filters.set({ sort: type ? `${sortName}.${type}` : null });
    };

    if (error || !data?.count) {
        return (
            <TableTemplate2
                isPagination
                totalData={0}
                totalPage={1}
                page={1}
                onSort={onSort}
                tableList={tableList}
                description="Saat ini, data Consumer Promotion belum tersedia."
                selectedRow={[]}
            />
        );
    }

    return (
        <TableTemplate2
            isLoading={isLoading}
            data={data?.data?.page_data}
            tableList={tableList}
            totalData={data?.count}
            totalPage={data?.data?.total_page}
            handlePageClick={handlePageClick}
            isPagination
            page={filters.page}
            limit={data?.count < 10 ? data?.count : filters.limit}
            onChangeLimit={onChangeLimit}
            isSearch={!!filters.searchParam}
            noResultSearchImage={<EmptyStateImage />}
            onSort={onSort}
            sortType={sortType}
            onCheckAllRow={onCheckAllRow}
            onChangeBulkCheckbox={onChangeBulkCheckbox}
            onClickByRow={onClickByRow}
            selectedRow={stateParahub.exportListParahub}
        />
    );
};

export default Table;
